module.exports = __webpack_public_path__ + "img/SWP_Hammer_2H_02.980a3369.png";